import { render, staticRenderFns } from "./Carrera.vue?vue&type=template&id=2a52efc4"
import script from "./Carrera.vue?vue&type=script&lang=js"
export * from "./Carrera.vue?vue&type=script&lang=js"
import style0 from "./Carrera.vue?vue&type=style&index=0&id=2a52efc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports